import "../modules/form.js";
import "../modules/imagePreview.js";
import "../modules/post.js";
import "../modules/postCode.js";

// TODO: 書くテンプレート分だけ追加する
import { pageMessage } from "./Nursery/message";
import { pageFeature } from "./Nursery/feature";
import { pagePolicy } from "./Nursery/policy";
import { pageCapacity } from "./Nursery/capacity";
import { pageBasic } from "./Nursery/basic";
import { pageFacility } from "./Nursery/facility";
import { pageStaff } from "./Nursery/staff";
import { pageRecruit } from "./Recruit/recruit";
import { pageDetail } from "./Nursery/detail";
import { pageImage } from "./image";
import { pageItem } from "./Life/item";
import { pageMeal } from "./Life/meal";
import { pageSchedule } from "./Life/schedule";
import { pageFaq } from "./Life/faq";
import { pageEvent } from "./Event/event";

// 初期実行
$(document).ready(function () {
    if ($(".js-page-edit").length === 0) {
        return;
    }

    // イベントページ専用の初期化（サイドメニューなしのフルページ）
    if ($(".nursery-event").length > 0) {
        pageEvent.reload();
        return;
    }

    // リンクを押したときの挙動。activeの付与
    $(".js-link").click(function () {
        const url = $(this).data("url");
        const paramList = new FormData();
        if ($(".nursery__side-menu-content").data("editing") === "true") {
            const check = confirm("行った変更が保存されない可能性があります。\n画面を切り替えてよろしいですか？");
            if (check) {
                $(".nursery__side-menu-content").data("editing", "false");
                window.removeEventListener("beforeunload", nursery.saveAlert);
                $(".js-link a").removeClass("current");
                $(this).find("a").addClass("current");
                nursery.postUrl(url, paramList);
            }
        } else {
            $(".js-link a").removeClass("current");
            $(this).find("a").addClass("current");
            nursery.postUrl(url, paramList);
        }
    });

    // 初期クリック
    $(".js-link:first").trigger("click");
});

const nursery = {
    postUrl: function (url, paramList) {
        switch (true) {
            case url === "/nursery/message":
                post.postAjaxData(url, paramList, "", pageMessage.loadDone, null, null);
                break;
            case url === "/nursery/feature":
                post.postAjaxData(url, paramList, "", pageFeature.loadDone, null, null);
                break;
            case url === "/nursery/policy":
                post.postAjaxData(url, paramList, "", pagePolicy.loadDone, null, null);
                break;
            case url === "/nursery/capacity":
                post.postAjaxData(url, paramList, "", pageCapacity.loadDone, null, null);
                break;
            case url === "/nursery/facility":
                post.postAjaxData(url, paramList, "", pageFacility.loadDone, null, null);
                break;
            case url === "/nursery/basic":
                post.postAjaxData(url, paramList, "", pageBasic.loadDone, null, null);
                break;
            case url === "/nursery/staff":
                post.postAjaxData(url, paramList, "", pageStaff.loadDone, null, null);
                break;
            case url === "/nursery/recruit/hero":
            case url === "/nursery/recruit/values":
            case url === "/nursery/recruit/stats":
            case url === "/nursery/recruit/interviews":
            case url === "/nursery/recruit/contact":
                post.postAjaxData(url, paramList, "", pageRecruit.loadDone, null, null);
                break;
            case url === "/nursery/recruit/gallery":
                paramList.append("typeId", "10");
                post.postAjaxData(url, paramList, "", pageImage.loadDone, null, null);
                break;
            case url === "/nursery/detail":
                post.postAjaxData(url, paramList, "", pageDetail.loadDone, null, null);
                break;
            case url === "/nursery/item":
                post.postAjaxData(url, paramList, "", pageItem.loadDone, null, null);
                break;
            case url === "/nursery/meal":
                post.postAjaxData(url, paramList, "", pageMeal.loadDone, null, null);
                break;
            case url === "/nursery/schedule":
                post.postAjaxData(url, paramList, "", pageSchedule.loadDone, null, null);
                break;
            case url === "/nursery/faq":
                post.postAjaxData(url, paramList, "", pageFaq.loadDone, null, null);
                break;
            case url.match(/\/nursery\/image\?typeId=\d/).length > 0:
                post.postAjaxData(url, paramList, "", pageImage.loadDone, null, null);
                break;
            default:
                post.postAjaxData(url, paramList, "", pageImage.loadDone, null, null);
        }
    },
    saveAlert: function (e) {
        e.returnValue = "保存されていない内容は破棄されます。\n画面を切り替えてよろしいですか？";
    }
};
window.nursery = nursery;
